import { useState } from 'react';

import { InvoiceReport, KmsReport, ShiftsReport, TaxReport } from 'services/report.service';
import {
  IShiftReportItem,
  InvoiceReportData,
  InvoiceReportItem,
  ReportInvoiceCreateDto,
  ReportWithDatesAssigneeAndContactDto,
  ReportTaxCreateDto,
  ReportTaxData,
  ReportTaxExpenseItem,
  ReportTaxReceiptItem,
  ShiftReportData,
  KmsReportData,
} from 'models/report';
import { mapShift } from '../shift/hooks';
import { mapExpense } from '../expenses/hooks';
import moment from 'moment';
import { IExpense } from 'models';

function mapShiftReportData(obj: any): ShiftReportData {
  return {
    summary: obj.summary,
    data: obj.data.map((i: IShiftReportItem) => {
      if (i.isShift) {
        return mapShift(i);
      }
      return mapExpense(i);
    }),
  };
}

function mapKmReportData(obj: any): KmsReportData {
  return {
    summary: obj.summary,
    data: obj.data.map((i: IExpense) => mapExpense(i)),
  };
}

function mapReportTaxData(obj: any): ReportTaxData {
  return {
    summary: obj.summary,
    receipts: obj.receipts.map((i: ReportTaxReceiptItem) => {
      return {
        ...i,
        date: moment(i.date),
      };
    }),
    expenses: obj.expenses.map((i: ReportTaxExpenseItem) => {
      return {
        ...i,
        date: moment(i.date),
      };
    }),
  };
}

function mapInvoiceReportData(obj: any): InvoiceReportData {
  const mapInvoice = (i: InvoiceReportItem) => {
    return {
      ...i,
      date: moment(i.date),
      dueDate: moment(i.dueDate),
    };
  };
  return {
    summary: obj.summary,
    paid: obj.paid.map(mapInvoice),
    unpaid: obj.unpaid.map(mapInvoice),
    overdue: obj.overdue.map(mapInvoice),
    writtenOff: obj.writtenOff.map(mapInvoice),
  };
}
export function useReportShift() {
  const [loading, setIsLoading] = useState(false);
  const [obj, setObj] = useState<ShiftReportData | undefined>();

  const generate = async (payload: ReportWithDatesAssigneeAndContactDto) => {
    setIsLoading(true);
    try {
      const obj = await ShiftsReport(payload);
      setObj(mapShiftReportData(obj));
    } finally {
      setIsLoading(false);
    }
  };

  return { loading, obj, generate };
}

export function useReportKm() {
  const [loading, setIsLoading] = useState(false);
  const [obj, setObj] = useState<KmsReportData | undefined>();

  const generate = async (payload: ReportWithDatesAssigneeAndContactDto) => {
    setIsLoading(true);
    try {
      const obj = await KmsReport(payload);
      setObj(mapKmReportData(obj));
    } finally {
      setIsLoading(false);
    }
  };

  return { loading, obj, generate };
}
export function useReportTax() {
  const [loading, setIsLoading] = useState(false);
  const [obj, setObj] = useState<ReportTaxData | undefined>();

  const generate = async (payload: ReportTaxCreateDto) => {
    setIsLoading(true);
    try {
      const obj = await TaxReport(payload);
      setObj(mapReportTaxData(obj));
    } finally {
      setIsLoading(false);
    }
  };

  return { loading, obj, generate };
}

export function useReportInvoice() {
  const [loading, setIsLoading] = useState(false);
  const [obj, setObj] = useState<InvoiceReportData | undefined>();

  const generate = async (payload: ReportInvoiceCreateDto) => {
    setIsLoading(true);
    try {
      const obj = await InvoiceReport(payload);
      setObj(mapInvoiceReportData(obj));
    } finally {
      setIsLoading(false);
    }
  };

  return { loading, obj, generate };
}
